:host {
  display: flex;
  flex-direction: column;
  gap: var(--size-1);
  h2 {
    margin: 0;
    padding: 0;
    font-size: var(--scale-2);
  }
}
